import axios from 'axios';
import { authHeader } from './authservice/auth-header';

const API_URL_BE = process.env.VUE_APP_BASE_API_URL;

const API_URL = process.env.VUE_APP_BASE_API_URL_OSINT;
// const API_URL = "http://localhost:8000/";

class WebsiteService {

    // web info
    searchWebInfo(data) {
        return axios.post(API_URL+'website/web-info', data);
    }
    getWebInfo() {
        return axios.get(API_URL_BE+'webinfo', { headers: authHeader() });
    }
    getWebInfoDetail(id) {
        return axios.get(API_URL_BE+'webinfo/'+id, { headers: authHeader() });
    }
    createWebInfo(data) {
        return axios.post(API_URL_BE+'webinfo', data, { headers: authHeader() });
    }
    deleteWebInfo(id) {
        return axios.delete(API_URL_BE+'webinfo/'+id, { headers: authHeader() });
    }
    websiteBulkWebInfo(data) {
        return axios.post(API_URL_BE+'webinfo/bulk-delete', data, { headers: authHeader() });
    }


    // web ip location
    searchDomainLocation(data) {
        return axios.post(API_URL+'website/website-loc', data);
    } 
    getWebInfoLocation() {
        return axios.get(API_URL_BE+'ip-location', { headers: authHeader() });
    }
    getWebInfoLocationDetail(id) {
        return axios.get(API_URL_BE+'ip-location/'+id, { headers: authHeader() });
    }
    createWebInfoLocation(data) {
        return axios.post(API_URL_BE+'ip-location', data, { headers: authHeader() });
    }
    deleteWebInfoLocation(id) {
        return axios.delete(API_URL_BE+'ip-location/'+id, { headers: authHeader() });
    }
    websiteBulkWebLocation(data) {
        return axios.post(API_URL_BE+'ip-location/bulk-delete', data, { headers: authHeader() });
    }


    
    // web cms checker
    searchWebCms(data) {
        return axios.post(API_URL+'website/cms-checker', data);
    } 

    getWebCmsChecker() {
        return axios.get(API_URL_BE+'cms', { headers: authHeader() });
    }
    getWebCmsDetail(id) {
        return axios.get(API_URL_BE+'cms/'+id, { headers: authHeader() });
    }
    createWebCmsChecker(data) {
        return axios.post(API_URL_BE+'cms', data, { headers: authHeader() });
    }
    deleteWebCmsChecker(id) {
        return axios.delete(API_URL_BE+'cms/'+id, { headers: authHeader() });
    }
    websiteBulkWebCms(data) {
        return axios.post(API_URL_BE+'cms/bulk-delete', data, { headers: authHeader() });
    }


    // web web service
    searchWebService(data) {
    return axios.post(API_URL+'website/service', data);
    } 
    getWebServices() {
        return axios.get(API_URL_BE+'webservice', { headers: authHeader() });
    }
    getWebServicesDetail(id) {
        return axios.get(API_URL_BE+'webservice/'+id, { headers: authHeader() });
    }
    createWebService(data) {
        return axios.post(API_URL_BE+'webservice', data, { headers: authHeader() });
    }
    deleteWebServices(id) {
        return axios.delete(API_URL_BE+'webservice/'+id, { headers: authHeader() });
    }
    websiteBulkWebService(data) {
        return axios.post(API_URL_BE+'webservice/bulk-delete', data, { headers: authHeader() });
    }


   

    // web whois
    searchDomainWhois(data) {
        return axios.post(API_URL+'website/domain-lookup', data);
    }
    getWebWhois() {
        return axios.get(API_URL_BE+'whois', { headers: authHeader() });
    }
    getWebWhoisDetail(id) {
        return axios.get(API_URL_BE+'whois/'+id, { headers: authHeader() });
    }
    createWebWhois(data) {
        return axios.post(API_URL_BE+'whois', data, { headers: authHeader() });
    }
    deleteWebWhois(id) {
        return axios.delete(API_URL_BE+'whois/'+id, { headers: authHeader() });
    }
    websiteBulkWebWhois(data) {
        return axios.post(API_URL_BE+'whois/bulk-delete', data, { headers: authHeader() });
    }


    // web sub domain
    searchSubDomain(data) {
        return axios.post(API_URL+'website/sub-domain', data);
    } 
    getSubDomain() {
        return axios.get(API_URL_BE+'subdomain', { headers: authHeader() });
    }
    createSubDomain(data) {
        return axios.post(API_URL_BE+'subdomain', data, { headers: authHeader() });
    }
    getSubDomainDetail(id) {
        return axios.get(API_URL_BE+'subdomain/'+id, { headers: authHeader() });
    }
    deleteSubDomain(id) {
        return axios.delete(API_URL_BE+'subdomain/'+id, { headers: authHeader() });
    }
    websiteBulkWebSubdomain(data) {
        return axios.post(API_URL_BE+'subdomain/bulk-delete', data, { headers: authHeader() });
    }

    // private web
    createPrivateWeb(data) {
        return axios.post(API_URL_BE+'socmed/pwb', data, { headers: authHeader() });
    }
    // getSubDomainDetail(id) {
    //     return axios.get(API_URL_BE+'subdomain/'+id, { headers: authHeader() });
    // }
    deletePrivateWebsite(id) {
        return axios.delete(API_URL_BE+'socmed/pwb/'+id, { headers: authHeader() });
    }
    

}

export default new WebsiteService();
